<template>
    <v-container fill-height fluid style="padding: 0px; background-color: rgb(255, 136, 136);">
            <v-row class="d-flex justify-center">
                <v-col
                    class="d-flex justify-center"
                    cols="12"
                >
                    <h1 class="display-4 text-center ">!Estamos en Mantenimiento!</h1>
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    class="d-flex justify-center"
                    cols="12"
                >
                    <img src="/technician.png" height="400">
                </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
                <v-col
                    cols="5"
                >
                    <h1 class="text-center font-weight-thin">¡Volveremos a estar disponibles en breve!</h1>
                </v-col>
            </v-row>

            <v-row class="d-flex justify-center">
                <v-col
                    class=""
                    cols="3"
                >

                    <h3 class="text-center font-weight-thin">
                        Sentimos los posibles inconvenientes ocasionados, estamos realizando tareas de mantenimiento en este momento
                    </h3>                
                </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
                <v-col
                    class="d-flex justify-center"
                    cols="6"
                >

                    <h2 class="text-center font-weight-normal">
                        - El Equipo de MÁSMÁNAGER
                    </h2>
                </v-col>
            </v-row>
    </v-container>
</template>

<script>
export default{
    name: 'NavBar',
    beforeMount(){
        this.$store.dispatch('util/getMaintenanceStatus').then((response) => {
            if (!response.data)
                this.$router.push({ name: 'login' })
        })
    },
}
</script>